import React from 'react';

const Details = ({ handleDetailsSidebar, details, order }) => {

    return (
        <div className={details ? "orderDetailsActive" : "orderDetails"}>
            <div className="top-portion d-flex justify-content-start align-items-center">
                <span onClick={() => handleDetailsSidebar("close")}><i className="bi bi-arrow-left ms-4 me-3"></i></span>
                <span>{order?.order_number}</span>
            </div>
            <div className='address-portion d-flex justify-content-start align-items-center'>
                <i className="bi bi-geo-alt ms-4 me-3"></i>
                <span><b>600123, Singapor</b></span>
            </div>
            <div className='timestatus-portion mt-2'>
                <div className="row">
                    <div className="col-md-3 col-lg-3">
                        <ul className='mt-2 ms-3'>
                            <li className='time'> {order?.order_receivedtime}</li>
                            <li>Order Received</li>
                        </ul>
                    </div>
                    <div className="col-md-3 col-lg-3">
                        <ul className='mt-2 ms-3'>
                            <li className='time'>{order?.order_acceptedtime}</li>
                            <li>Order Accepted</li>
                            {/* <li><small>27 min - 12:08 PM</small></li> */}
                        </ul>
                    </div>
                    <div className="col-md-3 col-lg-3">
                        <ul className='mt-2 ms-3'>
                            <li className='time'>{order?.order_indeliverytime}</li>
                            <li>In Delivery</li>
                        </ul>
                    </div>
                    <div className="col-md-3 col-lg-3">
                        <ul className='mt-2 ms-3'>
                            <li className='time'>{order?.order_deliveredtime}</li>
                            <li>Order Delivered</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='details card-body mt-2'>
                <h3>Order Details</h3>
                <div className="row">


                    {
                        order?.order_items?.map(item =>
                            <div className="row mt-3">
                                <div className="col-md-12 col-lg-12">
                                    <div className="row">
                                        <div className="col-md-1 col-lg-1">
                                            <b>{item?.quantity}x</b>
                                        </div>
                                        <div className="col-md-11 col-lg-11">
                                            <b>{ item?.item?.name}</b>
                                            <b className="float-right">TK {item?.item?.price.toFixed(2) }</b>
                                            <div className="row">
                                                <div className="col-md-6 col-lg-6">
                                                   
                                                    <ul>
                                                        {item?.order_item_extra?.map(subitem => 
                                                            <li> {subitem?.quantity}x {subitem?.ingredients[0]?.name }</li>
                                                        )}
                                                    </ul>
                                                   
                                                </div>
                                                <div className="col-md-6 col-lg-6 float-right">
                                                    <ul className='float-end'>
                                                        {item?.order_item_extra?.map(subitem =>
                                                            <li>TK {subitem?.price.toFixed(2)}</li>
                                                        )}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                </div>
                <hr />
                <div className='row calculation'>
                    <div className="col-md-6 col-lg-6">
                        <ul>
                            <li className='fs-5 fw-bold'>Subtotal</li>
                            <li className='mt-2'>Delivery Fee</li>
                        </ul>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <ul style={{ marginRight: '20px' }}>
                            <li className='fs-5 fw-bold'>Tk {order?.grand_total }</li>
                            <li className='mt-2'>Tk 0</li>
                        </ul>
                    </div>
                </div>
                <hr />
                <div className='row total'>
                    <div className="col-md-6 col-lg-6">
                        <ul>
                            <li className='fs-5 fw-bold'>Total</li>
                        </ul>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <ul style={{ marginRight: '20px' }}>
                            <li className='fs-5 fw-bold'>Tk 502</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Details;
